// extracted by mini-css-extract-plugin
export var photoPopup = "styles-module__photoPopup___FE25G";